import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export const PaymentMethod = ({ data }: any) => {
  // 1. Define fixed color mapping
  const colorMap: Record<string, string> = {
    APPLEPAY: '#FF2A00',
    CASH: '#008048',
    CREDITCARD: '#35B1E8',
    KNET: '#DF6D14',
    WALLET: '#FF69B4',
  };

  // 2. Format label names nicely
  const formatName = (name: string) => {
    switch (name.toUpperCase()) {
      case 'APPLEPAY':
        return 'Apple Pay';
      case 'CASH':
        return 'Cash';
      case 'CREDITCARD':
        return 'Credit Card';
      case 'KNET':
        return 'KNET';
      case 'WALLET':
        return 'Wallet';
      default:
        return name;
    }
  };

  // 3. Ensure you map all data regardless of percentage
  const pieData = (data?.items || []).map((item: any) => ({
    name: formatName(item.Name),
    y: item.Percentage ?? 0,
    color: colorMap[item.Name.toUpperCase()] || undefined,
  }));

  // 4. Create chart config
  const chartOptions: Highcharts.Options = {
    chart: {
      type: 'pie',
      events: {
        render() {
          const chart = this as Highcharts.Chart & {
            customText?: Highcharts.SVGElement;
          };

          const total = chart.series[0].data.reduce(
            (sum: any, point: any) => sum + point.y,
            0,
          );
          const centerX = chart.plotLeft + chart.plotWidth / 2;
          const centerY = chart.plotTop + chart.plotHeight / 2;
          const text = `Total<br><b>${total.toFixed(1)}%</b>`;

          if (!chart.customText) {
            chart.customText = chart.renderer
              .text(text, centerX, centerY)
              .css({
                color: '#000000',
                fontSize: '16px',
                textAlign: 'center',
              })
              .attr({
                align: 'center',
                zIndex: 5,
              })
              .add();
          } else {
            chart.customText.attr({ text });
          }

          chart.customText.attr({
            x: centerX,
            y: centerY,
            align: 'center',
          });
        },
      },
    },
    title: {
      text: 'Payment Method',
      align: 'center',
      style: {
        fontSize: '13px',
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        innerSize: '60%',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.y:.1f}%',
          style: {
            fontSize: '0.9rm',
          },
        },
      },
    },
    tooltip: {
      pointFormat: '<b>{point.y:.1f}%</b>',
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: 'Payment Methods',
        type: 'pie',
        data: pieData,
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};
